import Logger from '../logging/logger';
import { getInactivityTimeout } from '../alert-popups/inactivity-controller';

function onPopupCloseProperty( event: CustomEvent ): void {
    const detail = event.detail || {};

    Logger.info( 'Event Triggered: onPopupCloseProperty', detail );

    if ( window.propertyMap ) {
        window.propertyMap.remove();
        window.propertyMap = null;
    }

    if ( window.mediaHandler ) {
        window.mediaHandler.remove();
        window.mediaHandler = null;
    }

    document.dispatchEvent( new CustomEvent( 'twc:alertable:timeout-change', {
        bubbles: true,
        detail: {
            timeout: getInactivityTimeout(),
        },
    } ) );
}

export default onPopupCloseProperty;
